<template>
  <div class="hello">
    <topHeader @changeViewFun="changeViewFun" :curPageId="currentView" />
    <component :is="currentView" @changeview="changeViewFun"></component>
    <Bottom @changeview="changeViewFun" />
  </div>
</template>

<script>
import topHeader from "@/components/topHeader";
import homecontent from "@/components/homecontent";
import Bottom from "@/components/bottom";
import ProductCenter from "@/components/ProductCenter";
import TechnicAlability from "@/components/technicAlability";
import CompanyIntroduction from "@/components/companyIntroduction";
import GovernmentEnterprisePark from "@/components/governmentEnterprisePark";
import carbinPark from "@/components/carbinPark";
import wisdomSmartWarehouse from "@/components/wisdomSmartWarehouse";
import productPark from "@/components/productPark";
export default {
  name: "HelloWorld",
  components: {
    topHeader,
    homecontent,
    Bottom,
    ProductCenter,
    TechnicAlability,
    CompanyIntroduction,
    GovernmentEnterprisePark,
    carbinPark,
    wisdomSmartWarehouse,
    productPark,
  },
  data() {
    return {
      currentView: "homecontent",
    };
  },
  methods: {
    changeViewFun(val) {
      this.currentView = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.hello {
  user-select: none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view.vue